import type { Throughput } from '../../portfolio';

/**
 * THE READING LINE beside the throughput sparkline — the answer in words, so the
 * line is only the evidence. One builder, shared by the roll-up (short) and the
 * status report (long), so the two never phrase the same trend differently.
 */

/** "~2/wk" — the board's recent norm, rounded for reading. */
function normWord(t: Throughput): string {
  return `~${Math.round(t.norm)}/wk`;
}

const ABOVE: Record<Throughput['dir'], string> = { up: 'above', down: 'below', flat: 'about' };

/** The compact reading for the roll-up cell: "4 closed · above the ~2/wk norm". */
export function throughputReading(t: Throughput): string {
  return `${t.thisWeek} closed · ${ABOVE[t.dir]} the ${normWord(t)} norm`;
}

/** The fuller reading for the status report: names the window and the average. */
export function throughputReadingLong(t: Throughput): string {
  const weeks = t.weekly.length;
  const avg = Math.round(t.norm);
  const rel =
    t.dir === 'up' ? 'above' : t.dir === 'down' ? 'below' : 'about the same as';
  return `${t.thisWeek} closed this week — ${rel} the recent average of about ${avg} a week (last ${weeks} weeks).`;
}
